import { connect } from 'react-redux'
import { RootState } from 'typesafe-actions';
import { ThunkDispatch } from 'redux-thunk';
import {  updateSupplierDeliveryTimesAsyncThunk, removeSupplierDeliveryTimeAsyncThunk } from '../actions/SupplierActions';
import SupplierDeliveryTimeSetter from '../components/SupplierDeliveryTimeSetter';
import { SupplierDeliveryTime } from '../../api/models/SupplierDeliveryTime';


const mapStateToProps = (state: RootState) => ({
    supplierInfo: state.supplierRdc.supplierInfo,
    deliveryTimes: state.supplierRdc.supplierDeliveryTimes,
    deliveryTimesBusy: state.supplierRdc.updateDeliveryTimesBusy
})

const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>) => {
    return ({
        updateSupplierDeliveryTimes: async (sdts: SupplierDeliveryTime[]) => {
            await dispatch(updateSupplierDeliveryTimesAsyncThunk(sdts))
        },
        removeSupplierDeliveryTime: async (sdt: SupplierDeliveryTime) => {
            await dispatch(removeSupplierDeliveryTimeAsyncThunk(sdt))
        }
    })
}

export type SupplierDeliveriesProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>

export const SupplierDeliveriesCnn = connect(
    mapStateToProps,
    mapDispatchToProps
)(SupplierDeliveryTimeSetter);